// Vendor libraries
import { createAction, props } from '@ngrx/store';
export const setViewRootFolder = createAction('[Folders] Set View Root Folder', props());
